import React, { useEffect } from "react";
import { createContext, useState } from "react";
import api from "../../services/api";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [signed, setSigned] = useState(false);
  const [isLead, setIsLead] = useState(false);

  useEffect(() => {
    const validateToken = () => {
      const tokenData = sessionStorage.getItem("authToken");
      if (tokenData) {
        api.defaults.headers.common = { Authorization: `Bearer ${tokenData}` };
        setSigned(true);
      }
    };
    validateToken();
  }, []);
  
  // --- FUNÇÃO EXISTENTE (Login/Senha) ---
  const sideIn = async(login, password) => {
    const data = {
      "login": login,
      "password": password
    }
    try {
      var resp = await api.post('login',data,{headers:{'Content-Type': 'application/json'}})
      api.defaults.headers.common['Authorization'] = `Bearer ${resp.data?.access_token}`
      sessionStorage.setItem('authToken',resp.data?.access_token)
      setSigned(true)
      const resultUser =  await getUser()
      return resultUser
    } catch (error) {
      if (error?.response?.status === 401) {
        return 'Usuário ou senha inválidos'
      }
    }
  }

  // --- NOVA FUNÇÃO 1: Solicitar Código via WhatsApp ---
  const requestLoginCode = async (phone) => {
    try {
      // Chama o novo endpoint do backend
      await api.post('login/request-code', { phone });
      // Retorna sucesso para o componente de login poder avançar
      return { success: true, message: 'Código enviado com sucesso!' };
    } catch (error) {
      if (error?.response?.status === 404) {
        return { success: false, message: 'Telefone não cadastrado.' };
      }
      return { success: false, message: 'Erro ao solicitar o código. Tente novamente.' };
    }
  };

  // --- NOVA FUNÇÃO 2: Verificar Código e Fazer Login ---
  const verifyLoginCode = async (phone, code) => {
    const data = { phone, code };
    try {
      // Chama o endpoint de verificação
      // O backend já retorna o JWT, assim como a rota 'login'
      var resp = await api.post('login/verify-code', data, { headers: { 'Content-Type': 'application/json' } });
      
      // Lógica de sucesso (idêntica ao 'sideIn')
      api.defaults.headers.common['Authorization'] = `Bearer ${resp.data?.access_token}`;
      sessionStorage.setItem('authToken', resp.data?.access_token);
      setSigned(true);
      
      const resultUser = await getUser(); // Reutiliza sua função de buscar usuário
      return resultUser; // Retorna '' em caso de sucesso
    } catch (error) {
      if (error?.response?.status === 401) { // 401 Unauthorized
        return 'Código inválido ou expirado';
      }
      return 'Erro ao verificar o código.';
    }
  };

// --- NOVO (CADASTRO) 1: Solicitar Código de Validação ---
  const requestPhoneValidationCode = async (phone) => {
    try {
      await api.post('lead/validation/request-code', { phone });
      
      return { success: true, message: 'Código enviado com sucesso!' };

    } catch (error) {
      // Exemplo: Se o backend retornar 409 (Conflict) se o tel já existir
      if (error?.response?.status === 409) { 
        return { success: false, message: 'Este telefone já está cadastrado.' };
      }
      return { success: false, message: 'Erro ao solicitar o código. Tente novamente.' };
    }
  };

  // --- NOVO (CADASTRO) 2: Verificar Código de Validação ---
  const verifyPhoneValidationCode = async (phone, code) => {
    try {
      await api.post('lead/validation/verify-code', { phone, code });
      return { success: true };

    } catch (error) {
      // 401 (Unauthorized) ou 400 (Bad Request)
      if (error?.response?.status === 401 || error?.response?.status === 400) {
        return { success: false, message: 'Código inválido ou expirado' };
      }
      return { success: false, message: 'Erro ao verificar o código.' };
    }
  };
  // --- FIM DOS NOVOS ---

  const getUser = async(token) => {
    // ... (sua função getUser existente, sem alterações)
    try {
      var resp = await api.get('user/me')
      sessionStorage.setItem('user',JSON.stringify(resp.data))
      return ''
    } catch (error) {
      return 'Não foi possivel buscar dados do usuario'
    }
  }

  const getRoutes = async() => {
    // ... (sua função getRoutes existente, sem alterações)
    try {
      const tokenData = sessionStorage.getItem('authToken')
      api.defaults.headers.common['Authorization'] = `Bearer ${tokenData}`
      var resp = await api.get('permissoes/rotas')
      return resp.data.result
    } catch (error) {
      return 'Não foi possivel buscar dados'
    }
  }

  const signup = (login, password) => {
    // ... (sua função signup existente)
    return api.auth(login,password)
  };

  const sideOut = () => {
    // ... (sua função sideOut existente)
    sessionStorage.clear()
  }


  return (
    <AuthContext.Provider
      value={{
        signed: sessionStorage.getItem("authToken")?.length > 0,
        sideOut,
        sideIn,
        signup,
        getRoutes,
        isLead,
        setIsLead,
        requestLoginCode,
        verifyLoginCode,
        requestPhoneValidationCode,
        verifyPhoneValidationCode,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// import React, { useEffect } from "react";
// import { createContext, useState } from "react";
// import api from "../../services/api";

// export const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [signed, setSigned] = useState(false);
//   const [isLead, setIsLead] = useState(false);

//   useEffect(() => {
//     const validateToken = () => {
//       const tokenData = sessionStorage.getItem("authToken");
//       if (tokenData) {
//         api.defaults.headers.common = { Authorization: `Bearer ${tokenData}` };
//         setSigned(true);
//       }
//     };
//     validateToken();
//   }, []);
  
//     const sideIn = async(login, password) => {
//       const data = {
//         "login": login,
//         "password": password
//       }
//       try {
//         var resp = await api.post('login',data,{headers:{'Content-Type': 'application/json'}})
//         api.defaults.headers.common['Authorization'] = `Bearer ${resp.data?.access_token}`
//         sessionStorage.setItem('authToken',resp.data?.access_token)
//         setSigned(true)
//        const resultUser =  await getUser()
//         return resultUser
//       } catch (error) {
//         if (error?.response?.status === 401) {
//           return 'Usuário ou senha inválidos'
//         }
//       }
//     }

//     const getUser = async(token) => {
      
//       try {
//         var resp = await api.get('user/me')
//         sessionStorage.setItem('user',JSON.stringify(resp.data))
//         return ''
//       } catch (error) {
//         return 'Não foi possivel buscar dados do usuario'
//       }
     
//     }

//     const getRoutes = async() => {
      
//       try {
//         const tokenData = sessionStorage.getItem('authToken')
//         api.defaults.headers.common['Authorization'] = `Bearer ${tokenData}`
//         var resp = await api.get('permissoes/rotas')
//         return resp.data.result
//       } catch (error) {
//         return 'Não foi possivel buscar dados'
//       }
     
//     }

//     const signup = (login, password) => {
            
//         return api.auth(login,password)
//       };

//     const sideOut = () => {
//       sessionStorage.clear()
//     }


//   return (
//     <AuthContext.Provider
//       value={{
//         signed: sessionStorage.getItem("authToken")?.length > 0,
//         sideOut,
//         sideIn,
//         signup,
//         getRoutes,
//         isLead,
//         setIsLead,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };
